export default "__VITE_ASSET__BpFYNSwB__"